<template>
  <v-container v-if="offerData.id" :loading="loading">
    <v-row>
      <v-col cols="4">
        <v-card>
          <v-card-media src="src" height="200px" />
          <v-card-title primary-title>
            Angebotsdaten
          </v-card-title>
          <v-card-text>
            <!-- Angebot -->
            <template v-if="offer">
              <v-row>
                <v-col cols="6" lg="4">
                  Angebotsnummer
                </v-col>
                <v-col v-text="offer.id" />
              </v-row>

              <v-row>
                <v-col cols="6" lg="4">
                  Angebotsdatum
                </v-col>
                <v-col v-text="getDateString(offer.created_at)" />
              </v-row>

              <v-row v-if="$page.props.user.permissions.offer.nwt_view">
                <v-col cols="6" lg="4">
                  Debitor
                </v-col>
                <v-col>
                  <v-select
                    v-model="offer.debitor_id"
                    :items="debitors"
                    item-value="id"
                    item-text="name"
                    @change="updateDebitor"
                  />
                </v-col>
              </v-row>

              <template v-if="offerData.enlarged_contract">
                <v-row>
                  <v-col cols="6" lg="4">
                    Erweiterung zu Vertrag
                  </v-col>
                  <v-col v-text="offerData.enlarged_contract.number" />
                </v-row>
                <v-row>
                  <v-col cols="6" lg="4">
                    Beginn der Erweiterung
                  </v-col>
                  <v-col v-text="getDateString(offerData.start_date)" />
                </v-row>
              </template>
              <template v-else>
                <v-row>
                  <v-col cols="6" lg="4">
                    Laufzeit
                  </v-col>
                  <v-col v-text="getTermString(offer.term_id)" />
                </v-row>

                <v-row v-if="offerData.premliminary_pug">
                  <v-col cols="6" lg="4">
                    PUG
                  </v-col>
                  <v-col v-text="offerData.premliminary_pug" />
                </v-row>
              </template>
            </template>
            <!-- Angebot - Ende -->
            <!-- Preisinformation -->
            <template v-else>
              <!-- Erweiterung -->
              <template v-if="offerData.enlarged_contract">
                <v-row>
                  <v-col cols="6" lg="4">
                    Erweiterung zu Vertrag
                  </v-col>
                  <v-col v-text="offerData.enlarged_contract.number" />
                </v-row>
                <v-row>
                  <v-col cols="6" lg="4">
                    Beginn der Erweiterung
                  </v-col>
                  <v-col v-text="getDateString(offerData.start_date)" />
                </v-row>
              </template>
              <template v-else>
                <v-row>
                  <v-col cols="6" lg="4">
                    Laufzeit
                  </v-col>
                  <v-col>
                    {{ runtime[0].text }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" lg="4">
                    PUG
                  </v-col>
                  <v-col>
                    {{ telekomPug[0].text }}
                  </v-col>
                </v-row>
              </template>
              <v-row>
                <v-col cols="6" lg="4">
                  Erstelldatum
                </v-col>
                <v-col v-text="getDateString(offerData.created_at)" />
              </v-row>
            </template>
            <!-- Preisinformation - Ende -->
            <v-row>
              <v-col cols="12">
                <v-divider />
              </v-col>
              <v-col cols="12" lg="4">
                <v-list-item-title>
                  Endkunde
                </v-list-item-title>
              </v-col>
              <v-col v-if="offerData.orderer">
                <v-list-item three-line class="pa-0">
                  <v-list-item-content class="pa-0">
                    <b><LinkCustomer :company="offerData.orderer.company" /></b>
                    <v-list-item-subtitle>
                      {{ offerData.orderer.branches[0].address.street }}
                      {{ offerData.orderer.branches[0].address.house_number }},
                      {{ offerData.orderer.branches[0].address.zip }}
                      {{ offerData.orderer.branches[0].address.city }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                      Ansprechpartner: {{ offerData.orderer.first_name }}
                      {{ offerData.orderer.last_name }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                      E-Mail:
                      {{
                        offerData.orderer.emails && offerData.orderer.emails[0]
                          ? offerData.orderer.emails[0].email
                          : "nicht gefunden"
                      }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                      Tel.:
                      {{
                        offerData.orderer.phone_numbers &&
                          offerData.orderer.phone_numbers[0]
                          ? offerData.orderer.phone_numbers[0].number
                          : "nicht gefunden"
                      }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>

            <performer-snippet
              :offer-data="offerData"
            />
            <team-snippet
              :offer-data="offerData"
            />
            <v-row>
              <v-col>
                Inhalt
              </v-col>
              <v-col>
                <ContentSnippet :offer-data="offerData" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-divider />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="commentForm.comment"
                  label="Kommentar"
                />
                <v-col cols="12">
                  <v-btn @click="updateComment">
                    speichern
                  </v-btn>
                </v-col>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col>
        <v-card>
          <v-card-title> Positionen </v-card-title>
          <v-data-table
            :headers="headers"
            :items="overview.data.positions"
            dense
            disable-sort
            disable-pagination
            hide-default-footer
          >
            <template #item="props">
              <tr :style="positionBackground(props.item.pos)">
                <td>{{ props.item.pos }}</td>
                <td>{{ props.item.title }}</td>
                <td>
                  <v-edit-dialog
                    v-if="
                      props.item.orderPositionItemId &&
                        $page.props.user.permissions.offer.admin_view
                    "
                    :return-value.sync="props.item.amount"
                    large
                    save-text="speichern"
                    cancel-text="zurück"
                    @save="updatePositionItem(props.item)"
                  >
                    <div>{{ props.item.amount }}</div>
                    <template #input>
                      <div class="mt-4">
                        {{ props.item.title }}
                      </div>
                      <v-text-field
                        v-model="props.item.amount"
                        type="number"
                        label="Anzahl"
                        autofocus
                        number
                      />
                    </template>
                  </v-edit-dialog>
                  <div v-else>
                    {{ props.item.amount }}
                  </div>
                </td>
                <td>{{ props.item.price ? new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(props.item.price) : "" }}</td>
                <td>{{ props.item.abrechnung }}</td>
              </tr>
            </template>
            <template #footer>
              <div class="text-end">
                Gesamtpreis monatlich: {{ new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(wholePrices.mon) }}<br>
                Gesamtpreis einmalig: {{ new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(wholePrices.k) }}
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { formattedDateString } from '@/plugins/formatDate.js'
import TeamSnippet from '@/Components/Offers/Snippets/TeamSnippet'
import PerformerSnippet from '@/Components/Offers/Snippets/PerformerSnippet'
import ContentSnippet from '@/Components/Offers/Snippets/ContentSnippet'
import LinkCustomer from '@/Components/Customer/Snippets/LinkCustomer'

export default {
   name: 'OrderOverview',
   components: {
      TeamSnippet,
      PerformerSnippet,
      ContentSnippet,
      LinkCustomer
   },
   props: {
      overview: {
         type: Object,
         required: true,
      },
      offerData: {
         type: Object,
         required: true,
      },
      editable: {
         type: Boolean,
         required: true,
      },
      offer: {
         type: Object,
         required: true,
      },
   },
   data () {
      return {
         loading: true,
         suche: '',
         headers: [
            {
               text: 'Pos.',
               align: 'start',
               filterable: false,
               value: 'pos',
            },
            { text: 'Beschreibung', value: 'title' },
            { text: 'Anz.', value: 'amount' },
            { text: 'Preis', value: 'amount' },
            { text: 'Art.', value: 'abrechnung' },
         ],
         terms: [
            { text: '36 Monate', value: 2 },
            { text: '60 Monate', value: 3 },
         ],
         pugs: {
            telekom: [
               { text: 'PUG 1', value: 1 },
               { text: 'PUG 2', value: 2 },
               { text: 'PUG 3', value: 3 },
            ],
            nwt: [
               { text: 'PUG 0', value: 0 },
               { text: 'PUG 1', value: 1 },
               { text: 'PUG 2', value: 2 },
               { text: 'PUG 3', value: 3 },
            ],
         },
         term: null,
         pug: {
            telekom: null,
            nwt: null,
         },
         commentForm: this.$inertia.form(
            {
               comment: this.offerData.comment,
            }
         ),
         debitors: []
      }
   },
   computed: {
      wholePrices () {
         const price = {
            mon: 0.0,
            k: 0.0,
         }
         this.overview.data.positions
            .filter((pos) => pos.amount && pos.amount !== null)
            .forEach((pos) => {
               if (pos.abrechnung === '1m') {
                  price.mon += parseFloat(pos.price ? pos.price : 0)
               } else {
                  price.k += parseFloat(pos.price ? pos.price : 0)
               }
            })
         return price
      },
      telekomPug () {
         return this.pugs.telekom.filter(obj => {
            return obj.value === this.pug.telekom
         })
      },
      runtime () {
         return this.terms.filter(obj => {
            return obj.value === this.term
         })
      }
   },
   mounted () {
      this.loadDebitors()
   },
   created () {
      this.term = this.offerData.term_id ? parseInt(this.offerData.term_id) : 3
      this.pug.telekom = this.offerData.preliminary_pug
         ? parseInt(this.offerData.preliminary_pug)
         : 2
      this.pug.nwt = this.offerData.scaled_price_pug
         ? parseInt(this.offerData.scaled_price_pug)
         : 0
   },
   methods: {
      loadDebitors () {
         fetch(this.route('debitor.list'))
            .then(response => response.json())
            .then(data => (this.debitors = data.debitors))
      },
      getDateString (date) {
         return formattedDateString(date)
      },
      getTermString (termid) {
         const termstring = this.terms.find((term) => term.value === termid)
         return termstring ? termstring.text : 'nicht festgelegt'
      },
      updatePositionItem (val) {
         this.$inertia.patch(
            this.route('positionitem.update', val.orderPositionItemId),
            {
               amount: val.amount,
            },
            {
               preserveScroll: true,
            }
         )
      },
      positionBackground (pos) {
         return {
            backgroundColor:
          pos !== undefined && !String(pos).includes('.')
             ? 'gray'
             : 'transparent',
         }
      },
      updateTerm () {
         this.$inertia.post(
            this.route('offerData.updateTerm', this.offerData.id),
            {
               term: this.term,
            },
            {
               preserveScroll: true,
            }
         )
      },
      updatePreliminaryPug () {
         this.$inertia.post(
            this.route('offerData.updatePreliminaryPug', this.offerData.id),
            {
               pug: this.pug.telekom,
            },
            {
               preserveScroll: true,
            }
         )
      },
      updateScaledPricePug () {
         this.$inertia.post(
            this.route('offerData.updateScaledPricePug', this.offerData.id),
            {
               pug: this.pug.nwt,
            },
            {
               preserveScroll: true,
            }
         )
      },
      updateComment () {
         this.commentForm.patch(this.route('offerData.updateComment', this.offerData.id), {
            preserveScroll: true
         })
      },
      updateDebitor () {
         this.$inertia.post(
            this.route('debitor.update.offer', {
               offer: this.offer.id
            }),
            {
               debitor_id: this.offer.debitor_id,
            }
         )
      }
   },
}
</script>
